<template>
  <div class="pb-2">
    <b-modal centered ref="modal" size="lg" :title="title" hide-footer>
      <div v-if="modalLoading" style="height: 100px">
        <b-spinner
            style="position: absolute; top: 25%; left: calc(50% - 15px); width: 30px; height: 30px;"
            label="Loading..."
        ></b-spinner>
      </div>
      <div v-for="(el, i) of modalData" :key="i" class="p-4">
        <h2 class="text-center my-4">{{ el.address }}</h2>
        <div
            v-for="(el, i) of el.images"
            class="m-4"
            style="overflow-y: auto"
            :key="i"
        >
          <img :src="el.img"/>
        </div>
      </div>
    </b-modal>

    <p v-if="loading" class="text-center">Chargement des images</p>
    <button class="text-center w-full p-1 font-weight-bold" v-if="showButton" @click="showModal">
      Afficher les images <br/>
      de livraison
    </button>
    <p v-if="!loading && !showButton" class="text-center">Pas d'image</p>
  </div>
</template>

<script>
import {api} from "@/Services/api.common.service";
import _ from "lodash";
import moment from "moment";

export default {
  props: {
    address: {type: Array},
    date: {type: String},
    addressMap: Object
  },
  data() {
    return {
      loading: true,
      showButton: false,
      modalData: {},
      modalLoading: false,
      images: {},
    };
  },
  computed: {
    title() {
      return moment(this.date, "YYYY-MM-DD").format("LL");
    },
  },
  async mounted() {
    await this.fetchData()
  },
  methods: {
    async fetchData() {
      try {
        this.images = (await Promise.all(
            this.address.map(async (address) => {
              const saved = localStorage.getItem(`deliveryImages-${address}-${this.date}`)

              if (saved) {
                const parsed = JSON.parse(saved)
                if (moment(parsed.expires).isAfter(moment())) {
                  return {
                    data: parsed.data,
                  }
                }
              }

              const response = await api().post("deliveryImages", {address, date: this.date, withImage: false})

              if (response && response.status === 200) {
                localStorage.setItem(`deliveryImages-${address}-${this.date}`, JSON.stringify({
                  expires: moment().add(10, 'minutes').format(),
                  data: response.data
                }))
              }

              return response
            })
        ))
            .map((x) => x.data)
            .filter((x) => x.images && x.images.length);
        this.loading = false;

        // filter if there is no image
        if (!this.images.filter((x) => x.images).length) return;

        this.showButton = true;
      } catch (e) {
        console.error("error", e);
      }
    },
    async showModal() {
      this.$refs["modal"].show();
      this.modalLoading = true;

      this.getImages().then(() => {
        const address = this.address.map((address) => ({
          address,
        }));

        this.modalData = _.merge(address, this.images)
            .filter((x) => x.images?.length)
            // remap with correct address name
            .map(item =>
                ({
                  ...item,
                  address: this.addressMap[item.address]
                }));
        this.modalLoading = false;
      })
    },
    closeModalDate() {
      this.$refs["modal"].hide();
    },
    async getImages() {
      const requests = this.images[0].images.map(image => api().post("deliveryImages/image", {imageUrl: image.url}));

      await Promise.all(requests).then(responses => {
        responses.forEach((resp, index) => this.images[0].images[index].img = resp.data.img)
      }).catch(error => {
        console.log(error)
      });
    }
  },
};
</script>

<style lang="scss" scoped></style>
